import { render } from "./index.vue?vue&type=template&id=71642c16&bindings={}"
import script from "./info-card.js?vue&type=script&lang=js"
export * from "./info-card.js?vue&type=script&lang=js"

import "./info-card.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script